export enum FooterEvents {
  BasementClick = 'footer_tap',
}
